// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-streight {
  padding-top: 40px;
}
.password-streight div {
  margin-bottom: 7.5px;
  padding-left: 50px;
  color: #cccccc;
}
.password-streight div:first-child {
  font-weight: 800;
  color: #999999;
}
.password-streight .success {
  margin-right: 10px;
  margin-top: 7px;
  width: 5px;
  height: 5px;
  float: left;
  border-radius: 50%;
  background-color: #22b7ff;
}
.password-streight .fail {
  width: 5px;
  height: 5px;
  margin-right: 10px;
  color: #e57373;
  float: left;
}

.show-password {
  margin-top: 20px;
}
.show-password span {
  margin-left: 5px;
}

.msg-error {
  color: #e57373;
}

.msg-success {
  color: #22b7ff;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/minha-conta/configuracoes/card-alterar-senha/card-alterar-senha.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAGA;EACI,iBAAA;AAFJ;AAGI;EACI,oBAAA;EACA,kBAAA;EACA,cCWI;ADZZ;AAEQ;EACI,gBAAA;EACA,cCOA;ADPZ;AAGI;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBCbG;ADYX;AAGI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cCOC;EDND,WAAA;AADR;;AAKA;EACI,gBAAA;AAFJ;AAGI;EACI,gBAAA;AADR;;AAKA;EACI,cCNK;ADIT;;AAKA;EACI,cCpCO;ADkCX","sourcesContent":["\n@import '../../../../../../../sass/variables';\n\n.password-streight {\n    padding-top: 40px;\n    div {\n        margin-bottom: 7.5px;\n        padding-left: 50px;\n        color: $cinza-400;\n        &:first-child {\n            font-weight: 800;\n            color: $cinza-500;\n        }\n    }\n    .success {\n        margin-right: 10px;\n        margin-top: 7px;\n        width: 5px;\n        height: 5px;\n        float: left;\n        border-radius: 50%;\n        background-color: $azul-400;\n    }\n    .fail {\n        width: 5px;\n        height: 5px;\n        margin-right: 10px;\n        color: $danger;\n        float: left;\n    }\n}\n\n.show-password {\n    margin-top: 20px;\n    span {\n        margin-left: 5px;\n    }\n}\n\n.msg-error {\n    color: $danger;\n}\n\n.msg-success {\n    color: $azul-400;\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
